import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import GradientBadge from "@/modules/vue/components/GradientBadge.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Skill',
  props: {
    skill: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(GradientBadge, {
        value: __props.skill,
        class: "w-8"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.skill === undefined ? '-' : Math.floor(__props.skill)), 1)]),
        _: 1
      }, 8, ["value"]);
    };
  }
});